/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LivekitServerDto } from '../models/LivekitServerDto';
import type { LivekitServerRequestDto } from '../models/LivekitServerRequestDto';
import type { UpdateLivekitSecretRequestDto } from '../models/UpdateLivekitSecretRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LiveKitServerApiService {
    /**
     * List LiveKit servers
     * @returns LivekitServerDto Successful response
     * @throws ApiError
     */
    public static listLivekitServers(): CancelablePromise<Array<LivekitServerDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/livekit/servers',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
            },
        });
    }
    /**
     * Create LiveKit server
     * @param requestBody
     * @returns LivekitServerDto Created
     * @throws ApiError
     */
    public static createLivekitServer(
        requestBody: LivekitServerRequestDto,
    ): CancelablePromise<LivekitServerDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/telecom/livekit/servers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                409: `Resource already exists`,
            },
        });
    }
    /**
     * Get LiveKit server by id
     * @param id
     * @returns LivekitServerDto Successful response
     * @throws ApiError
     */
    public static getLivekitServerById(
        id: string,
    ): CancelablePromise<LivekitServerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/livekit/servers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Update LiveKit server
     * @param id
     * @param requestBody
     * @returns LivekitServerDto Updated
     * @throws ApiError
     */
    public static updateLivekitServer(
        id: string,
        requestBody: LivekitServerRequestDto,
    ): CancelablePromise<LivekitServerDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/livekit/servers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
                409: `Resource already exists`,
            },
        });
    }
    /**
     * Delete LiveKit server
     * @param id
     * @returns void Deleted
     * @throws ApiError
     */
    public static deleteLivekitServer(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/telecom/livekit/servers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Update LiveKit server API secret
     * @param id
     * @param requestBody
     * @returns void Secret updated
     * @throws ApiError
     */
    public static updateLivekitServerSecret(
        id: string,
        requestBody: UpdateLivekitSecretRequestDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/livekit/servers/{id}/secret',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Assign organization to LiveKit server
     * @param id
     * @param organizationId
     * @returns void Assigned
     * @throws ApiError
     */
    public static assignOrganizationToLivekitServer(
        id: string,
        organizationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/livekit/servers/{id}/organizations/{organizationId}',
            path: {
                'id': id,
                'organizationId': organizationId,
            },
            errors: {
                400: `Invalid input`,
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Get assigned LiveKit server by organization id
     * @param organizationId
     * @returns LivekitServerDto Successful response
     * @throws ApiError
     */
    public static getLivekitServerByOrganization(
        organizationId: string,
    ): CancelablePromise<LivekitServerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/livekit/servers/organizations/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden - SuperAdmin access required`,
                404: `Resource not found`,
            },
        });
    }
}
